import React from "react";
import { Box } from "@mui/material";
import { LOGIN_REACHIQ_LOGO, SORRY_IMAGE } from "../../utils/constants/assets";
import { styles } from "./styles";

import { Anchor, RightsTag } from "../../components";
import {
  GET_EARLY_ACCESS,
  PRIVACY_POLICY_LINK,
  TERMS_SERVICE_LINK,
} from "../../utils/constants/httpConstants";
import Typography from "../../components/Typography/Typography";
import { GREY } from "../../utils/colors";
import { fontWeight } from "../../utils/constants/UI";
import Button from "../../components/Buttons/Button";
import { Strings } from "./strings";
import Image from "../../image/Image";
import { useNavigate } from "react-router-dom";
import { HOME_PATH } from "../../utils/constants/routes";

const InvalidRouteScreen = () => {
  const classes = styles();
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate(HOME_PATH)
  };

  return (
    <Box className={classes.Head}>
      <Box className={classes.logo_container}>
        <Image
          onClick={handleNavigation}
          src={LOGIN_REACHIQ_LOGO}
          className={classes.reachiqLogo}
        />
      </Box>
      <Box className={classes.invalidContentContainer}>
        <div className={classes.ImageBorder}>
          <Image className={classes.Image} src={SORRY_IMAGE} />
        </div>

        <div className={classes.sorryTitle}>
          {" "}
          <Typography
            size={"dsm"}
            color={GREY.PRIMARY}
            fontWeight={fontWeight.SEMIBOLD}
            label={Strings.SORRY}
          />
        </div>
        <div className={classes.SubHead}>
          <Typography
            size={"sm"}
            color={GREY.TERTIARY}
            fontWeight={fontWeight.SEMIBOLD}
            label={Strings.LOOKS_LIKE}
          />
          <Typography
            size={"sm"}
            color={GREY.TERTIARY}
            fontWeight={fontWeight.SEMIBOLD}
            label={Strings.PLEASE_CLICK}
          />

        </div>
        <p className={classes.sorryPara}></p>
        <Box className={classes.Top}>
          {" "}
          <Button
            size={"sm36"}
            variant={"primary"}
            label={Strings.SIGN_UP}
            onClick={handleNavigation}
          />
        </Box>
      </Box>
      <Box className={classes.contains}>
        <div className={classes.containPolicy}>
          <RightsTag className={classes.termsPara} />
          {/* Privacy and Terms. */}
          <Anchor
            href={PRIVACY_POLICY_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            <Typography
              label={Strings.PRIVACY}
              color={GREY.SECONDARY}
              size={"xs"}
              fontWeight={fontWeight.SEMIBOLD}
            />
          </Anchor>
          <div className={classes.TypoHead}>
            <Typography
              label={Strings.AND}
              color={GREY.TERTIARY}
              size={"xs"}
              fontWeight={fontWeight.REGULAR}
            />
          </div>
          <Anchor
            href={TERMS_SERVICE_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            <Typography
              label={Strings.TERMS}
              color={GREY.SECONDARY}
              size={"xs"}
              fontWeight={fontWeight.SEMIBOLD}
            />
          </Anchor>
        </div>
      </Box>
    </Box>
  );
};

export default InvalidRouteScreen;
